import { render, staticRenderFns } from "./LogosAnswer.vue?vue&type=template&id=05c5f74f&scoped=true&lang=html&"
import script from "./LogosAnswer.vue?vue&type=script&lang=coffee&"
export * from "./LogosAnswer.vue?vue&type=script&lang=coffee&"
import style0 from "./LogosAnswer.vue?vue&type=style&index=0&id=05c5f74f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c5f74f",
  null
  
)

component.options.__file = "LogosAnswer.vue"
export default component.exports